module.exports = __webpack_public_path__ + "img/backgroundImg4.a39515be.png";